import React from 'react';
const Placeholder = (children, className, placeholder) => React.createElement('p', {
    className,
    style: {
        position: 'relative',
        width: 'fit-content',
    },
}, 
// eslint-disable-next-line react/no-children-prop
React.createElement('span', {
    contentEditable: false,
    children: placeholder,
    style: {
        color: '#DBE2E6',
        maxWidth: '100%',
        pointerEvents: 'none',
        wordBreak: 'break-word',
    },
}), 
// eslint-disable-next-line react/no-children-prop
React.createElement('span', {
    children,
    style: {
        height: '100%',
        left: '0px',
        position: 'absolute',
        top: 0,
        width: '100%',
    },
}));
export { Placeholder };
//# sourceMappingURL=Placeholder.js.map